import type { FC } from 'react';

import { XingletLoader } from '@xing-com/crate-xinglet';

export const InsightSection: FC<{ name: 'hero' | 'salary' | 'jobs' }> = ({
  name,
}) => (
  <XingletLoader name={`@xing-com/crate-insights-${name}-carousel-section`} />
);
